import { render, staticRenderFns } from "./input-other.component.vue?vue&type=template&id=98124992"
import script from "./input-other.component.ts?vue&type=script&lang=ts&external"
export * from "./input-other.component.ts?vue&type=script&lang=ts&external"
import style0 from "./input-other.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports